import { useState, useEffect } from 'react';
import { PageHeader } from '@/ui/PageHeader';
import { FormSection } from '@/ui/FormSection';
import { FormFieldWrapper } from '@/ui/FormField';
import { Input } from '@/ui/base/input';
import { Textarea } from '@/ui/base/textarea';
import { Button } from '@/ui/base/button';
import { Spinner } from '@/ui/Spinner';
import { usePortalConfig } from '@/lib/usePortalConfig';
import { avisarAcaoIndisponivel } from '@/modulos/admin/portal-publico/avisoIndisponivel';
import { Settings, Save } from 'lucide-react';

export default function PortalConfigPage() {
  const { data: config, isLoading } = usePortalConfig();
  const [form, setForm] = useState({
    footer_descricao: '',
    footer_copyright: '',
    footer_lgpd: '',
    contato_telefone: '',
    contato_email: '',
    contato_endereco: '',
  });

  useEffect(() => {
    if (config) {
      setForm({
        footer_descricao: config.footer_descricao || '',
        footer_copyright: config.footer_copyright || '',
        footer_lgpd: config.footer_lgpd || '',
        contato_telefone: config.contato_telefone || '',
        contato_email: config.contato_email || '',
        contato_endereco: config.contato_endereco || '',
      });
    }
  }, [config]);

  if (isLoading) return <Spinner size="lg" fullPage />;

  const handleSave = () => {
    avisarAcaoIndisponivel();
  };

  return (
    <div className="w-full max-w-3xl mx-auto space-y-6">
      <PageHeader
        title="Configurações do Portal"
        description="Textos gerais do rodapé, contato e LGPD do portal TEG."
      />
      <FormSection title="Rodapé" icon={Settings}>
        <FormFieldWrapper label="Descrição do rodapé">
          <Textarea
            value={form.footer_descricao}
            onChange={(e) => setForm({ ...form, footer_descricao: e.target.value })}
            rows={3}
          />
        </FormFieldWrapper>
        <FormFieldWrapper label="Texto de copyright" hint="Use {ano} para o ano atual">
          <Input
            value={form.footer_copyright}
            onChange={(e) => setForm({ ...form, footer_copyright: e.target.value })}
          />
        </FormFieldWrapper>
        <FormFieldWrapper label="Texto LGPD">
          <Input
            value={form.footer_lgpd}
            onChange={(e) => setForm({ ...form, footer_lgpd: e.target.value })}
          />
        </FormFieldWrapper>
      </FormSection>
      <FormSection title="Dados de contato" icon={Settings}>
        <FormFieldWrapper label="Telefone">
          <Input
            value={form.contato_telefone}
            onChange={(e) => setForm({ ...form, contato_telefone: e.target.value })}
          />
        </FormFieldWrapper>
        <FormFieldWrapper label="E-mail">
          <Input
            value={form.contato_email}
            onChange={(e) => setForm({ ...form, contato_email: e.target.value })}
          />
        </FormFieldWrapper>
        <FormFieldWrapper label="Endereço">
          <Input
            value={form.contato_endereco}
            onChange={(e) => setForm({ ...form, contato_endereco: e.target.value })}
          />
        </FormFieldWrapper>
      </FormSection>
      <div className="flex justify-end">
        <Button onClick={handleSave}>
          <Save className="h-4 w-4 mr-2" />
          Salvar configurações
        </Button>
      </div>
    </div>
  );
}
